// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__9Zfjs","range":"MonthRangeSwitch_range__1Jad9","disabled":"MonthRangeSwitch_disabled__kXU2O"};